const DomainModel = {
  domain: '',
  status: 'bad'
};

export default DomainModel;
